<template>
  <div class="pages-myInfo">
    <img
      class="cover"
      :src="avatar || require('../../images/teacherCover.png')"
      alt=""
    />
    <div class="name">
      <div class="">{{ nick_name }}</div>
      <img
        @click="toEditNmae"
        class="edit-icon"
        src="../../images/editIcon.png"
        alt=""
      />
    </div>
    <div class="phone">
      <div class="phone-title">我的手机号</div>
      <div class="phone-num">
        {{ hidePhone(user_name) }}
        <div class="phone-btn" @click="toEditPhone">更换手机号</div>
      </div>
    </div>
    <div class="password" @click="toEditPassword">修改密码</div>

    <div v-if="editName" class="mask">
      <div class="edit-info">
        <div class="edit-close" @click="closeEditName"></div>
        <div class="edit-title">修改信息</div>
        <div class="edit-line" style="padding-bottom: 17px">
          <div class="edit-line-title">头像：</div>
          <img
            class="edit-line-img"
            :src="avatar || require('../../images/teacherCover.png')"
            alt=""
          />
          <div class="edit-line-upload">
            重新上传
            <input class="upload-abs" type="file" @change="uploadFile" />
          </div>
        </div>
        <div class="edit-line">
          <div class="edit-line-title">姓名：</div>
          <el-input
            v-model="nick_name"
            placeholder="请输入内容"
            style="width: 224px"
          ></el-input>
        </div>
        <div class="submit" @click="submitNameAvatar">提交</div>
      </div>
    </div>

    <div v-if="editPhone" class="mask">
      <div class="edit-info">
        <div class="edit-close" @click="closeEditPhone"></div>
        <div class="edit-title">更换手机号</div>
        <div class="edit-line">
          <div class="edit-line-title" style="width: 129px">
            {{ editPhoneStep == 1 ? '原手机号：' : '新手机号：' }}
          </div>
          <el-input
            v-model="phone"
            :placeholder="
              editPhoneStep == 1 ? '请输入原手机号' : '请输入新手机号'
            "
            style="width: 224px"
          ></el-input>
          <div v-if="!sendSms" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms" class="get-code">{{ smsTimes }}s</div>
        </div>
        <div class="edit-line">
          <div class="edit-line-title" style="width: 129px">验证码：</div>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 224px"
          ></el-input>
        </div>
        <div
          @click="next"
          :class="{ submit: true, 'phone-next-no': !phone || !code }"
        >
          {{ editPhoneStep == 1 ? '下一步' : '提交' }}
        </div>
      </div>
    </div>
    <div v-if="editPhoneSuccess" class="mask">
      <div class="edit-phone-success">
        <div class="edit-close" @click="closeEditPhoneSuccess"></div>
        <img
          class="edit-phone-success-img"
          src="../../images/editSuccess.png"
          alt=""
        />
        <div class="edit-phone-success-des">手机号修改成功，请重新登录。</div>
      </div>
    </div>

    <div v-if="editPassword" class="mask">
      <div class="edit-info">
        <div class="edit-close" @click="closeEditPassword"></div>
        <div class="edit-title">修改密码</div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">原密码：</div>
          <el-input
            v-model="password"
            placeholder="请输入原密码"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">
            <!-- {{ editPhoneStep == 1 ? '原手机号：' : '新手机号：' }} -->
            手机号：
          </div>
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
            style="width: 224px"
          ></el-input>
          <div v-if="!sendSms" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms" class="get-code">{{ smsTimes }}s</div>
        </div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">验证码：</div>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="editPasswordStep == 2" class="edit-line">
          <div class="edit-line-title">新密码：</div>
          <el-input
            v-model="passwordNew"
            placeholder="请输入新密码"
            style="width: 224px"
            show-password
          ></el-input>
        </div>
        <div v-if="editPasswordStep == 2" class="edit-line">
          <div class="edit-line-title">确认密码：</div>
          <el-input
            v-model="passwordNewAgain"
            placeholder="请再次输入新密码"
            style="width: 224px"
            show-password
          ></el-input>
        </div>
        <div
          @click="nextPassword"
          :class="{
            submit: true,
            'phone-next-no':
              (editPasswordStep == 1 && (!phone || !code || !password)) ||
              (editPasswordStep == 2 && (!passwordNew || !passwordNewAgain)),
          }"
        >
          {{ editPasswordStep == 1 ? '下一步' : '提交' }}
        </div>
      </div>
    </div>
    <div v-if="editPasswordSuccess" class="mask">
      <div class="edit-phone-success">
        <div class="edit-close" @click="closeEditPasswordSuccess"></div>
        <img
          class="edit-phone-success-img"
          src="../../images/editSuccess.png"
          alt=""
        />
        <div class="edit-phone-success-des">密码修改成功，请重新登录。</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  upload,
  userSave,
  send_sms,
  sms_auth,
  send_sms2,
  update_phone,
  update_self,
  check_phone_status,
} from '@/api/api.js'
export default {
  name: 'MyInfo',
  data: () => ({
    userInfo: {},
    coverFile: {},
    avatar: '', // 头像
    nick_name: '', // 昵称
    user_name: '', // 帐号

    editName: false, // 编辑名称头像
    editPhone: false, // 编辑电话
    editPhoneStep: 1, // 1原手机号 2新手机号
    phone: '',
    code: '',
    sendSms: false,
    sendFirst: true,
    editPhoneSuccess: false, // 编辑电话成功

    editPassword: false, // 编辑密码
    editPasswordStep: 1,
    password: '',
    passwordNew: '',
    passwordNewAgain: '',
    editPasswordSuccess: false, // 编辑密码成功

    sendInterval: null,
    smsTimes: 0,
  }),
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('yey-user'))
    this.userInfo = userInfo
    this.avatar = userInfo.avatar
    this.nick_name = userInfo.nick_name
    this.user_name = userInfo.user_name
  },
  methods: {
    hidePhone(phone) {
      if (phone.length !== 11) {
        return phone
      }
      let newPhone = phone.substr(0, 3) + '******' + phone.substr(8)
      return newPhone
    },
    uploadFile(e) {
      console.log('file', e.target.files)
      let file = e.target.files[0]
      var _URL = window.URL || window.webkitURL
      this.coverFile = {
        type: 'image',
        url: _URL.createObjectURL(file),
        file: file,
        name: file.name,
      }
      this.avatar = this.coverFile.url
    },
    toEditNmae() {
      this.editName = true
    },
    closeEditName() {
      this.editName = false
    },
    async submitNameAvatar() {
      if (!this.nick_name) {
        this.$message.error('请先填写名称!')
        return
      }
      let avatar = this.avatar
      if (this.coverFile.file) {
        let formData = new FormData()
        formData.append('file', this.coverFile.file)
        let fileRes = await upload(formData)
        console.log('fileRes', fileRes)
        let ossOrigin = 'https://ms-yey.oss-cn-shanghai.aliyuncs.com/'
        avatar = `${ossOrigin}${fileRes.data.data.url}`
      }
      let data = {
        // role: 'teacher',
        // id: this.userInfo.id,
        nick_name: this.nick_name,
        avatar,
      }
      console.log('data', data)
      update_self(data).then((res) => {
        console.log('update_self', res)
        let userInfo = JSON.parse(localStorage.getItem('yey-user'))
        userInfo.nick_name = this.nick_name
        userInfo.avatar = avatar
        localStorage.setItem('yey-user', JSON.stringify(userInfo))
        this.$message({
          type: 'success',
          message: '修改成功!',
        })
        this.editName = false
        this.$emit('onRefreshImg')
        this.$eventBus.$emit('refreshUserName')
        // setTimeout(() => {
        //   this.$router.back()
        // }, 500)
      })
    },

    toEditPhone() {
      this.editPhone = true
    },
    closeEditPhone() {
      this.editPhone = false
      this.sendSms = false
      this.sendFirst = true
      this.editPhoneStep = 1
      clearInterval(this.sendInterval)
    },
    async toSendSms() {
      console.log('phone', this.phone)
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (this.sendSms) {
        return
      }

      if (this.editPhoneStep == 2) {
        let phoneStatus = 0 // 0未注册(审核不通过) 1注册了未审核 2审核成功
        let phoneRes = await check_phone_status({ phone: this.phone })
        console.log('phoneRes', phoneRes)
        if (phoneRes.data.data == '手机号已注册，已审核') {
          phoneStatus = 2
          this.$message.error('手机号已被注册')
          return
        }
        if (phoneRes.data.data == '手机号已注册，待审核') {
          phoneStatus = 1
          this.$message.error('手机号已被注册，等待审核')
          return
        }
      }

      let res = null
      //   if (this.editPhoneStep == 1) {
      //     res = await send_sms2({ phone: this.phone })
      //   } else {
      //     res = await send_sms({ phone: this.phone })
      //   }
      res = await send_sms2({
        phone: this.phone,
        new_phone: this.editPhoneStep == 2 ? 1 : 0,
      })
      console.log('send_sms', res)
      if (res.data.code == -1) {
        if (res.data.msg == '触发分钟级流控Permits:1') {
          this.$message.error('验证码获取频繁，请于1分钟后再次尝试')
          return
        }
        if (res.data.msg == '触发小时级流控Permits:5') {
          this.$message.error('验证码获取频繁，请于1小时后再次尝试')
          return
        }
        if (res.data.msg == '触发天级流控Permits:10') {
          this.$message.error('验证码获取频繁，请于1天后再次尝试')
          return
        }
        this.$message.error(res.data.msg)
        return
      }
      this.sendSms = true
      this.sendFirst = false
      this.smsTimes = 59
      clearInterval(this.sendInterval)
      this.sendInterval = setInterval(() => {
        this.smsTimes = this.smsTimes - 1
        if (this.smsTimes < 1) {
          this.sendSms = false
          clearInterval(this.sendInterval)
        }
      }, 1000)
    },
    async next() {
      //   if (this.editPhoneStep == 1) {
      //     this.editPhoneStep = 2
      //     this.phone = ''
      //     this.code = ''
      //     return
      //   } else {
      //     this.editPhone = false
      //     this.editPhoneSuccess = true
      //   }
      //   return
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (!this.code) {
        this.$message.error('请先填写验证码')
        return
      }
      if (this.editPhoneStep == 1) {
        let res = await sms_auth({ phone: this.phone, v_code: this.code })
        console.log('sms_auth', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.phone = ''
        this.code = ''
        this.editPhoneStep = 2
        this.sendFirst = true
        this.sendSms = false
        clearInterval(this.sendInterval)
      } else {
        let res = await update_phone({ phone: this.phone, v_code: this.code })
        console.log('update_phone', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.editPhone = false
        this.editPhoneSuccess = true
        setTimeout(() => {
          this.closeEditPhoneSuccess()
        }, 2000)
      }
    },
    closeEditPhoneSuccess() {
      localStorage.removeItem('yey-user')
      localStorage.removeItem('yey-token')
      sessionStorage.removeItem('yey-mineMenuIndex')
      this.$router.push('/login')
      //   this.editPhoneSuccess = false
    },

    toEditPassword() {
      this.editPassword = true
    },
    closeEditPassword() {
      this.editPassword = false
      this.editPasswordStep = 1
      this.password = ''
      this.phone = ''
      this.code = ''
    },
    async nextPassword() {
      //   if (this.editPasswordStep == 1) {
      //     this.editPasswordStep = 2
      //   } else {
      //     this.editPassword = false
      //     this.editPasswordSuccess = true
      //   }
      //   return

      if (this.editPasswordStep == 1) {
        if (!this.password) {
          this.$message.error('请先填写原密码')
          return
        }
        let password = localStorage.getItem('yey-password')
        if (this.password !== password) {
          this.$message.error('原密码错误')
          return
        }
        if (!this.phone) {
          this.$message.error('请先填写手机号')
          return
        }
        if (!this.code) {
          this.$message.error('请先填写验证码')
          return
        }
        let res = await sms_auth({ phone: this.phone, v_code: this.code })
        console.log('sms_auth', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.phone = ''
        this.code = ''
        this.editPasswordStep = 2
      } else {
        let password = localStorage.getItem('yey-password')
        if (this.passwordNew == password) {
          this.$message.error('新密码不能与原密码相同')
          return
        }
        if (!this.passwordNew || !this.passwordNewAgain) {
          this.$message.error('请先填写密码')
          return
        }
        if (this.passwordNew !== this.passwordNewAgain) {
          this.$message.error('两次密码输入不一致')
          return
        }
        if (this.passwordNew.length < 8) {
          this.$message.error('密码最短为8位')
          return
        }
        update_self({ password: this.passwordNew }).then((res) => {
          console.log('update_self', res)
          if (res.data.code == -1) {
            this.$message.error(res.data.msg)
            return
          }
          this.editPassword = false
          this.editPasswordSuccess = true
          localStorage.setItem('yey-password', this.passwordNew)
          setTimeout(() => {
            this.closeEditPasswordSuccess()
          }, 2000)
        })
      }
    },
    closeEditPasswordSuccess() {
      //   this.editPasswordSuccess = false
      localStorage.removeItem('yey-user')
      localStorage.removeItem('yey-token')
      this.$router.push('/login')
    },

    // async submit() {
    //   if (!this.nick_name) {
    //     this.$message.error('请先填写名称!')
    //     return
    //   }
    //   let reg = /^1[3456789]\d{9}$/
    //   // if (!reg.test(this.user_name)) {
    //   //   this.$message.error('请填写正确手机号!')
    //   //   return
    //   // }
    //   let avatar = this.avatar
    //   if (this.coverFile.file) {
    //     let formData = new FormData()
    //     formData.append('file', this.coverFile.file)
    //     let fileRes = await upload(formData)
    //     console.log('fileRes', fileRes)
    //     let ossOrigin = 'https://ms-yey.oss-cn-shanghai.aliyuncs.com/'
    //     avatar = `${ossOrigin}${fileRes.data.data.url}`
    //   }
    //   console.log('avatar', avatar)
    //   let data = {
    //     role: 'teacher',
    //     id: this.userInfo.id,
    //     nick_name: this.nick_name,
    //   }
    //   console.log('data', data)
    // },
  },
}
</script>

<style lang="less" scoped>
.pages-myInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-left: 80px;
  box-sizing: border-box;
  .cover {
    width: 112px;
    height: 112px;
    border-radius: 56px;
  }
  .name {
    position: relative;
    display: flex;
    align-items: center;
    height: 68px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 68px;
    .edit-icon {
      position: absolute;
      top: 23px;
      right: -41px;
      width: 21px;
      height: 22px;
      // margin-left: 20px;
      cursor: pointer;
    }
  }
  .phone {
    margin-top: 10px;
    display: flex;
    border-radius: 10px;
    border: 1px solid #add1f4;
    .phone-title {
      width: 190px;
      height: 96px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 96px;
      text-align: center;
      border-right: 1px solid #add1f4;
    }
    .phone-num {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 350px;
      height: 96px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      .phone-btn {
        margin-left: 10px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #27b2fe;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .password {
    width: 121px;
    height: 40px;
    margin-top: 60px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #27b2fe;
    border-radius: 4px;
    cursor: pointer;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(#000, 0.7);
  }
  .edit-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
    }
  }
  .edit-info {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 526px;
    // height: 287px;
    padding-bottom: 26px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .edit-title {
      padding: 16px 0 0 30px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 36px;
    }
    .edit-line {
      display: flex;
      align-items: center;
      padding: 10px 0;
      //   padding: 10px 0 10px 127px;
      .edit-line-title {
        width: 175px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        text-align: right;
      }
      .edit-line-img {
        width: 54px;
        height: 54px;
        border-radius: 27px;
      }
      .edit-line-upload {
        position: relative;
        width: 56px;
        height: 22px;
        margin-top: 32px;
        margin-left: 2px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #27b2fe;
        line-height: 22px;
        text-align: center;
        border-radius: 20px;
        border: 1px solid #27b2fe;
        .upload-abs {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: 0;
          opacity: 0;
        }
      }
      .get-code {
        width: 114px;
        height: 40px;
        margin-left: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #00aeff;
        line-height: 40px;
        text-align: center;
        background: rgba(39, 178, 254, 0.1);
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .submit {
      width: 140px;
      height: 42px;
      margin: 20px auto 0;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      background: #27b2fe;
      border-radius: 100px;
      cursor: pointer;
    }
    .phone-next-no {
      background: rgba(39, 178, 254, 0.2);
    }
  }

  .edit-phone-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 412px;
    height: 168px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .edit-phone-success-img {
      width: 54px;
      height: 54px;
    }
    .edit-phone-success-des {
      margin-top: 10px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }
  }
}
</style>
